import PropTypes from "prop-types";
import React, { PureComponent } from "react";

import CheckboxStates from "../../constants/checkboxStates";
import { PropTypeShapes } from "../../types";
import { getLabelWithUntitled } from "../../utils/labelUtils";
import preprocessorQuery from "../../utils/preprocessorQuery";
import FormCheckbox from "../form/FormCheckbox";
import SplitButton from "../form/SplitButton";
import Icon from "../interface/Icon";
import { withPopoverRepositionContext } from "../popover/PopoverRepositionContext";

const isMobile = preprocessorQuery.isMobile();

const renderOptions = (options, onChange) =>
  options.map(o =>
    o.children && o.children.size ? (
      <TreeListGroupView key={o.value} group={o} onChange={onChange} />
    ) : (
      <FormCheckbox
        key={o.value}
        checkboxState={o.selected}
        label={getLabelWithUntitled(o.label)}
        disabled={o.disabled}
        onChange={state => onChange(o.value, state)}
        isCheckboxStyle={true}
      />
    )
  );

class TreeListGroupView extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      expanded: true
    };
    this.toggleCollapse = this.toggleCollapse.bind(this);
  }

  componentWillMount() {
    this.setState({
      expanded: this.props.group.state === CheckboxStates.MIXED
    });
  }

  componentDidUpdate() {
    if (this.props.repositionPopover) {
      this.props.repositionPopover();
    }
  }

  toggleCollapse() {
    this.setState({
      expanded: !this.state.expanded
    });
  }

  render() {
    let collapseArrow = (
      <Icon
        icon={
          this.props.group.children && this.props.group.children.size
            ? this.state.expanded
              ? "downArrow"
              : "rightArrow"
            : ""
        }
        className="collapseArrow"
        color="iconMono"
        onClick={this.toggleCollapse}
      />
    );
    if (isMobile && (!this.props.group.children || !this.props.group.children.size)) {
      collapseArrow = null;
    }
    return (
      <div className={`treeListGroupView`}>
        <div className="treeListGroupHeader">
          {collapseArrow}
          <FormCheckbox
            checkboxState={this.props.group.state ? this.props.group.state : this.props.group.selected}
            label={this.props.group.label}
            disabled={this.props.group.disabled}
            onChange={state => this.props.onChange(this.props.group.value, state)}
            isCheckboxStyle={true}
          />
          {this.props.group.allowAdd ? (
            <SplitButton
              label="Create"
              icon="sidebarAdd"
              linkStyle={true}
              onClick={() => (this.props.onAdd ? this.props.onAdd(this.props.group.value) : null)}
            />
          ) : null}
        </div>
        {this.state.expanded ? (
          <div className="treeListGroupChildren">{renderOptions(this.props.group.children, this.props.onChange)}</div>
        ) : null}
        {this.props.group.borderBelow ? <div className="treeListDivider" /> : null}
      </div>
    );
  }
}

TreeListGroupView.propTypes = {
  group: PropTypeShapes.listOptionGroup.isRequired,
  onChange: PropTypes.func.isRequired,
  onAdd: PropTypes.func,
  repositionPopover: PropTypes.func
};

export default withPopoverRepositionContext(TreeListGroupView);
